import { HttpClient } from '@angular/common/http';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import {
  PadAgreementGuestCheckoutService,
  PadAgreementPaymentLinksService,
  PadAgreementPlatformService,
  PadAgreementService,
} from '../services';
import { Injectable } from '@angular/core';

export const padAgreementServiceFactory = (
  httpClient: HttpClient,
  appConfig: AppConfigSettings,
) => {
  let service: PadAgreementService;

  if (appConfig.getconfig('usePaymentLinkEndpoints') === 'true') {
    service = new PadAgreementPaymentLinksService(httpClient, appConfig);
  } else if (appConfig.getconfig('useHostedPaymentsPageEndpoints') === 'true') {
    service = new PadAgreementGuestCheckoutService(httpClient, appConfig);
  } else {
    service = new PadAgreementPlatformService(httpClient, appConfig);
  }

  return service;
};

@Injectable({
  providedIn: 'root',
})
export class PadAgreementServiceFactory {
  constructor(
    private httpClient: HttpClient,
    private appConfig: AppConfigSettings,
  ) {}

  create() {
    return padAgreementServiceFactory(this.httpClient, this.appConfig);
  }
}
